<template lang="pug">
div.icon-container
    v-icon(small :color="iconColor") {{ icon }}
</template>

<script lang="ts">
import Vue from 'vue'
import {Component} from 'vue-property-decorator'
import {ICellRendererParams} from 'ag-grid-community'
import {Invoice} from '@/model/billing/Invoice'

@Component({
  components: {}
})
export default class StatusCircle extends Vue {
  private iconColor: string = ''
  private icon: string = ''

  refresh (params: ICellRendererParams): boolean {
    this.updateIconColor(params)

    return true
  }

  updateIconColor (params: ICellRendererParams): void {
    const invoice: Invoice = params.data

    if (params.node.rowPinned) {
      this.iconColor = 'transparent'
    } else {
      this.icon = invoice.paymentStatusIcon
      this.iconColor = invoice.paymentStatusColor
    }
  }

  mounted() {
    //@ts-ignore
    this.updateIconColor(this.params)
  }
}
</script>

<style lang="stylus" scoped>
.icon-container
  text-align center
</style>